import DeviceDetail from '@src/components/_shared/devices/DeviceDetail';
import DeviceListContainer from '@src/components/_shared/devices/DeviceListContainer';
import DeviceMasterDetail from '@src/components/_shared/devices/DeviceMasterDetail';
import { generateSx } from '@src/components/_shared/sxStyles/Datatable/deviceTableList';
import { DeviceRow } from '@src/types/devices/DeviceRow.types';
import { memo } from 'react';
import { useDeviceWidget } from './DeviceWidgetProvider';

interface DeviceDetailPanelProps {
  row: DeviceRow;
  unitControllerId: string;
  unitControllerEngineeringId: string;
}

const DeviceDetailPanel = memo<DeviceDetailPanelProps>(
  ({ row, unitControllerId, unitControllerEngineeringId }) => {
    const { config, isUnitScope } = useDeviceWidget();
    const { widgetIds, stylePrefix, errorMessageId } = config;
    const sx = generateSx(stylePrefix);

    return (
      <DeviceMasterDetail
        row={row}
        unitControllerId={unitControllerId}
        wrapperSx={sx.detailWrapper}
      >
        {(deviceId, controllerId) => (
          <>
            <DeviceDetail
              deviceId={deviceId}
              widgetInternalId={widgetIds.detail}
              unitControllerId={controllerId}
              unitControllerEngineeringId={unitControllerEngineeringId}
              errorMessageId={errorMessageId}
              isUnitScope={isUnitScope}
            />
            {widgetIds.children.map((child) => (
              <DeviceListContainer
                key={child.key}
                deviceId={deviceId}
                widgetInternalId={child.widgetId}
                unitControllerId={controllerId}
                unitControllerEngineeringId={unitControllerEngineeringId}
                idPrefix={child.idPrefix}
                sx={sx.detailDataTable}
                isUnitScope={isUnitScope}
              />
            ))}
          </>
        )}
      </DeviceMasterDetail>
    );
  },
);

DeviceDetailPanel.displayName = 'DeviceDetailPanel';

export default DeviceDetailPanel;
